import { useEffect, useState } from "react"
import { getActebiCategory } from "../service/service"
import { Link } from "react-router-dom"

function SakrebuloActsList({setActList,actList}) {
    console.log(actList)
      const [list, setList] = useState([])
    
        useEffect(()=>{
            const getList = async () =>{
                await getActebiCategory().then(item => {
                    setList(item)
                })
            }
            getList();
        },[])


        const handleClicke = (slug) => {
                  setActList(slug);
        };

  return (
    <>
      {list?.map(item => (
        <span key={item.id}>
          <Link  onClick={() => handleClicke(item.slug)} to={`/${item.slug}/${item.slug === "komisiebis-skhdomis-oqmebi" ? '1' : ''}`}>
            {item.title}
          </Link>
        </span>
      ))}
    </>
  )
}

export default SakrebuloActsList
